module.exports = __webpack_public_path__ + "img/suzu_dragon.d7977208.png";